// Browser-side purchase conversions for a completed in-app upgrade:
// GTM/GA4 "purchase", the Meta pixel "Subscribe" (same eventID as the server's
// Conversions API call, so Meta dedupes the pair) and PostHog "Subscribed".
// Every tracker is optional on the page; a missing one is a no-op.

function safely(label, call) {
    try {
        call()
    } catch (error) {
        try {
            console.warn(`[purchase] ${label} failed:`, error)
        } catch (ignored) {
            // nothing else to do
        }
    }
}

export function firePurchasePixels({
    plan,
    amount, // minor units, as Chargebee reports them
    currency,
    username,
    fbEventId,
}) {
    if (typeof window === 'undefined') return
    const value = Number.isFinite(amount) ? amount / 100 : undefined
    const transactionId = `${username || 'user'}_${Date.now()}`
    const item = { item_name: plan, price: value, quantity: 1 }

    safely('dataLayer', () => {
        if (!window.dataLayer || !window.dataLayer.push) return
        window.dataLayer.push({
            event: 'Purchase',
            ecommerce: {
                transaction_id: transactionId,
                value,
                currency,
                items: [item],
            },
        })
    })
    safely('gtag', () => {
        if (typeof window.gtag !== 'function') return
        window.gtag('event', 'purchase', {
            transaction_id: transactionId,
            value,
            currency,
            items: [item],
        })
    })
    safely('fbq', () => {
        if (typeof window.fbq !== 'function') return
        window.fbq(
            'track',
            'Subscribe',
            { value, currency },
            fbEventId ? { eventID: fbEventId } : undefined
        )
    })
    safely('posthog', () => {
        window.posthog?.capture?.('Subscribed', { plan, value, currency })
    })
}
